 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin~auth~banner-create~banner-details~campaigns-send~categories-create~categories-details~course-c~3fdd989f":"admin~auth~banner-create~banner-details~campaigns-send~categories-create~categories-details~course-c~3fdd989f","auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~942ebe80":"auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~942ebe80","auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~5426bd90":"auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~5426bd90","auth":"auth","admin~banner-create~banner-details~banners~campaigns~campaigns-send~categories~categories-create~cat~e954b370":"admin~banner-create~banner-details~banners~campaigns~campaigns-send~categories~categories-create~cat~e954b370","admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details":"admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details","admin":"admin","campaigns-send":"campaigns-send","categories-create":"categories-create","categories-details":"categories-details","exercises-items-create":"exercises-items-create","exercises-items-details":"exercises-items-details","banner-create":"banner-create","banner-details":"banner-details","courses-create":"courses-create","courses-details":"courses-details","exercises-create":"exercises-create","exercises-details":"exercises-details","users":"users","course-categories-create":"course-categories-create","course-categories-details":"course-categories-details","videos-create~videos-details":"videos-create~videos-details","videos-create":"videos-create","videos-details":"videos-details","banners~campaigns~categories~courses~courses-categories~exercises~exercises-items~reports~videos":"banners~campaigns~categories~courses~courses-categories~exercises~exercises-items~reports~videos","banners":"banners","campaigns":"campaigns","categories":"categories","courses":"courses","courses-categories":"courses-categories","exercises":"exercises","exercises-items":"exercises-items","videos":"videos","push-notification":"push-notification","reports":"reports","home":"home","content":"content","inbox":"inbox"}[chunkId]||chunkId) + "." + {"admin~auth~banner-create~banner-details~campaigns-send~categories-create~categories-details~course-c~3fdd989f":"d1a8645a","auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~942ebe80":"ef9e7e94","auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~5426bd90":"3a4dc667","auth":"56a41abe","admin~banner-create~banner-details~banners~campaigns~campaigns-send~categories~categories-create~cat~e954b370":"a16a5d9d","admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details":"eff1ea43","admin":"9b772e7d","campaigns-send":"083e8270","categories-create":"d7ad42aa","categories-details":"695cc76f","exercises-items-create":"f65e1a08","exercises-items-details":"48980ea8","banner-create":"898fb7ad","banner-details":"dd1499fa","courses-create":"89b18f22","courses-details":"1cceb78d","exercises-create":"be5dcb7d","exercises-details":"2b218ccc","users":"f3305af3","course-categories-create":"c8626ac9","course-categories-details":"279535f3","videos-create~videos-details":"6e7f439f","videos-create":"c3bd344e","videos-details":"132add63","banners~campaigns~categories~courses~courses-categories~exercises~exercises-items~reports~videos":"44609519","banners":"ca20328d","campaigns":"e7ca2902","categories":"b1f294a4","courses":"9db26db3","courses-categories":"fe7511a1","exercises":"2b6d2b2b","exercises-items":"e979363c","videos":"ce9eabaa","push-notification":"fe445636","reports":"9f106c8c","home":"1ed86b54","content":"c5287d25","inbox":"411c1d79"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~942ebe80":1,"auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~5426bd90":1,"auth":1,"admin~banner-create~banner-details~banners~campaigns~campaigns-send~categories~categories-create~cat~e954b370":1,"admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details":1,"admin":1,"campaigns-send":1,"categories-create":1,"categories-details":1,"exercises-items-create":1,"exercises-items-details":1,"banner-create":1,"banner-details":1,"courses-create":1,"courses-details":1,"exercises-create":1,"exercises-details":1,"users":1,"course-categories-create":1,"course-categories-details":1,"videos-create~videos-details":1,"videos-create":1,"banners~campaigns~categories~courses~courses-categories~exercises~exercises-items~reports~videos":1,"banners":1,"campaigns":1,"categories":1,"courses":1,"courses-categories":1,"exercises":1,"exercises-items":1,"videos":1,"push-notification":1,"reports":1,"home":1,"content":1,"inbox":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin~auth~banner-create~banner-details~campaigns-send~categories-create~categories-details~course-c~3fdd989f":"admin~auth~banner-create~banner-details~campaigns-send~categories-create~categories-details~course-c~3fdd989f","auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~942ebe80":"auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~942ebe80","auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~5426bd90":"auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~5426bd90","auth":"auth","admin~banner-create~banner-details~banners~campaigns~campaigns-send~categories~categories-create~cat~e954b370":"admin~banner-create~banner-details~banners~campaigns~campaigns-send~categories~categories-create~cat~e954b370","admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details":"admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details","admin":"admin","campaigns-send":"campaigns-send","categories-create":"categories-create","categories-details":"categories-details","exercises-items-create":"exercises-items-create","exercises-items-details":"exercises-items-details","banner-create":"banner-create","banner-details":"banner-details","courses-create":"courses-create","courses-details":"courses-details","exercises-create":"exercises-create","exercises-details":"exercises-details","users":"users","course-categories-create":"course-categories-create","course-categories-details":"course-categories-details","videos-create~videos-details":"videos-create~videos-details","videos-create":"videos-create","videos-details":"videos-details","banners~campaigns~categories~courses~courses-categories~exercises~exercises-items~reports~videos":"banners~campaigns~categories~courses~courses-categories~exercises~exercises-items~reports~videos","banners":"banners","campaigns":"campaigns","categories":"categories","courses":"courses","courses-categories":"courses-categories","exercises":"exercises","exercises-items":"exercises-items","videos":"videos","push-notification":"push-notification","reports":"reports","home":"home","content":"content","inbox":"inbox"}[chunkId]||chunkId) + "." + {"admin~auth~banner-create~banner-details~campaigns-send~categories-create~categories-details~course-c~3fdd989f":"31d6cfe0","auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~942ebe80":"0bce84aa","auth~banner-create~banner-details~banners~campaigns~categories~courses~courses-categories~courses-cr~5426bd90":"9a6b3fcb","auth":"2125ac4e","admin~banner-create~banner-details~banners~campaigns~campaigns-send~categories~categories-create~cat~e954b370":"5c7bcf4d","admin~campaigns-send~categories-create~categories-details~exercises-items-create~exercises-items-details":"c5443cd2","admin":"19aa6bee","campaigns-send":"b6a82aad","categories-create":"d7d331f7","categories-details":"d7d331f7","exercises-items-create":"60660384","exercises-items-details":"60660384","banner-create":"1f2561ad","banner-details":"1f2561ad","courses-create":"aa82ad12","courses-details":"aa82ad12","exercises-create":"6fac8866","exercises-details":"6fac8866","users":"907c211e","course-categories-create":"4832eb3c","course-categories-details":"4832eb3c","videos-create~videos-details":"2d7f15d3","videos-create":"60660384","videos-details":"31d6cfe0","banners~campaigns~categories~courses~courses-categories~exercises~exercises-items~reports~videos":"3c7b7d8e","banners":"1a277322","campaigns":"f408e11a","categories":"1a277322","courses":"1a277322","courses-categories":"1a277322","exercises":"1a277322","exercises-items":"1a277322","videos":"1a277322","push-notification":"60660384","reports":"10f44d33","home":"e263b8e2","content":"7afea8bb","inbox":"8d757688"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
